<h2 mat-dialog-title>{{ 'dialog.confirm.title' | transloco }}</h2>
<mat-dialog-content>
  <!--p>{{ 'dialog.confirm.message' | transloco }}</p-->
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="onDismiss()">{{ 'no' | transloco }}</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">{{ 'yes' | transloco }}</button>
</mat-dialog-actions>
